import React from 'react'

import Reflux from 'reflux-react-16'

import LoginStore from '../../stores/LoginStore.js'
import LoginActions from '../../actions/LoginActions.js'

import {Alert, Button, Card, Colors, H3, Spinner} from '../../components/UI/index.js'
import LoadingPage from './LoadingPage.js'
import t from 'src/helpers/Languages.js'

/** The link in the mail to confirm a new email address (#602), in the style of Wachtwoord wijzigen. */
export default class ConfirmEmail extends Reflux.Component {
    constructor(props) {
        super(props)
        this.state = {email: '', error: '', loading: true}
        this.store = LoginStore
    }

    componentDidMount() {
        document.title = t('emailChangeTitle')

        LoginActions.confirmEmailChange(this.props.match.params.token, (err, email) => {
            this.setState({loading: false, error: err || '', email: email || ''})
        })
    }

    render() {
        const {email, error, loading, brandingLoading, branding} = this.state

        if (brandingLoading) {
            return <LoadingPage />
        }

        return (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh', overflowY: 'auto', background: Colors.backgroundNeutral}}>
                <div style={{width: '100%', maxWidth: 474, padding: '0 12px'}}>
                    <Card shadow='true' style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', maxWidth: 450, padding: 24, marginTop: 120, marginLeft: 'auto', marginRight: 'auto'}}>
                        <img style={{maxHeight: 128, maxWidth: 256, marginBottom: 50, objectFit: 'contain'}} src={branding?.mainLogo || '/images/VELOYDLOGO.png'} />

                        <H3 style={{marginBottom: 36}}>{t('emailChangeTitle')}</H3>

                        {loading && <Spinner />}
                        {email && <Alert style={{marginBottom: 6}} variant='success'>{t('emailChanged', email)}</Alert>}
                        {error && <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>}

                        <Button
                            style={{width: '100%', marginTop: 24}}
                            color={branding?.color || Colors.brandColor}
                            onClick={() => window.location = '/login'}
                        >
                            {t('login')}
                        </Button>
                    </Card>
                </div>
            </div>
        )
    }
}
